module.exports = __webpack_public_path__ + "static/media/Grasmaaier.d4190813.mp3";